import React, { FC } from 'react';
import { Start, Stop, Svg } from './styles';

const Sun: FC<SVGIconProps> = ({ linearGradient }) => (
  <Svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M9.4665 50.9067L13.2265 54.6667L18.0265 49.8933L14.2398 46.1067M31.9998 16C23.1732 16 15.9998 23.1733 15.9998 32C15.9998 40.8267 23.1732 48 31.9998 48C40.8265 48 47.9998 40.8267 47.9998 32C47.9998 23.1467 40.8265 16 31.9998 16ZM53.3332 34.6667H61.3332V29.3333H53.3332M45.9732 49.8933L50.7732 54.6667L54.5332 50.9067L49.7598 46.1067M54.5332 13.3333L50.7732 9.59999L45.9732 14.3733L49.7598 18.16M34.6665 2.66666H29.3332V10.6667H34.6665M18.0265 14.3733L13.2265 9.59999L9.4665 13.3333L14.2398 18.16L18.0265 14.3733ZM2.6665 34.6667H10.6665V29.3333H2.6665M34.6665 53.3333H29.3332V61.3333H34.6665"
      fill="url(#paint0_linear_204_109)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_204_109"
        x1="32"
        y1="-26.5"
        x2="46"
        y2="66"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Sun;
